import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { LocalStorageService } from './local-storage-service.service';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {
  constructor(private router: Router,
  private nav: NavController,
  private localStorageService: LocalStorageService,
)  {}

  saveUser(token: any) {
    if(token.token){
      this.localStorageService.setItem('token', token.token);
    }
    this.localStorageService.setItem('user_id',token.cdUser);
    //this.localStorageService.setItem("mail", token.mail);
  }

  clearUser() {
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("cart_no");
    //localStorage.removeItem("mail");
  }

  getToken() {
    return localStorage.getItem("token");
  }

  logout() {
    this.clearUser();
    // this.router.navigate(["/login"], { queryParams: { returnUrl: state.url } });
    this.nav.navigateRoot("/login");
  }
}
